import axios from 'axios'
import router from '@/router'
import { API_BASE_URL, API_TIMEOUT } from '@/config/env'

// Create axios instance
const axiosInstance = axios.create({
  baseURL: API_BASE_URL || 'http://localhost:3000',
  timeout: API_TIMEOUT || 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const token = localStorage.getItem('auth_token')

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // Return the response data directly
    return response.data
  },
  (error) => {
    // Handle errors
    if (error.response) {
      const { status, data } = error.response
      const errorMessage = data?.message || error.message

      // Log error for debugging
      console.error(`API Error [${status}]:`, errorMessage)

      switch (status) {
        case 401:
          // Unauthorized - clear auth and redirect to login
          localStorage.removeItem('auth_token')
          localStorage.removeItem('auth_user')

          if (router.currentRoute.value.name !== 'login') {
            router.push({
              name: 'login',
              query: { redirect: router.currentRoute.value.fullPath }
            })
          }
          break

        case 403:
          // Forbidden - let components handle with useErrorHandler
          console.warn('Access forbidden:', errorMessage)
          break

        case 404:
          
          // router.push({
          //   name: 'error',
          //   params: { code: '404' },
          //   query: { message: errorMessage }
          // })
          break

        case 408:
          // Request timeout - let components handle
          console.warn('Request timeout:', errorMessage)
          break

        case 422:
          // Validation errors - let components handle
          console.warn('Validation error:', data.errors || errorMessage)
          break

        case 429:
          // Too many requests - let components handle
          console.warn('Too many requests:', errorMessage)
          break

        case 500:
        case 502:
        case 503:
        case 504:
          // Server errors - let components handle with useErrorHandler
          console.error('Server error:', errorMessage)
          break

        default:
          // Other errors - let components handle
          console.error('API error:', errorMessage)
      }

      // Enhance error object with response data
      const enhancedError = new Error(errorMessage)
      enhancedError.status = status
      enhancedError.data = data
      enhancedError.response = error.response

      return Promise.reject(enhancedError)
    }

    // Network error - let components handle with useErrorHandler
    if (error.request) {
      console.error('Network error: No response received from server')

      const networkError = new Error('Network error. Please check your connection.')
      networkError.status = 'network'
      return Promise.reject(networkError)
    }

    // Other errors
    console.error('Unexpected error:', error.message)
    return Promise.reject(error)
  }
)

export default axiosInstance
